module.exports = __webpack_public_path__ + "static/media/cert_12488.4d3216da.jpg";